<template>
  <section class="admin-content" id="contact-search">
    <div class="bg-dark m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-center mx-auto text-white p-b-30">
            <div class="m-b-10">
              <div class="avatar">
                <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
              </div>
            </div>
            <p class="h4"><strong>Complete Registration</strong></p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 offset-md-3" v-if="showdependent == true">
      <div class="spacer-top-bot">
        <button
          type="button"
          class="btn btn-outline-dark mx-2"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          Proceed to Pay
        </button>
      </div>
    </div>

    <section class="" v-show="showpay">
      <div class="container">
        <div class="row list">
          <div class="col-lg-8 offset-lg-2">
            <div class="card m-b-30">
              <div class="card-header">
                <p class="h5 text-center">
                  {{ auth_user.full_name }}
                </p>

                <div class="avatar mx-auto d-block">
                  <label class="avatar-input">
                    <span class="avatar avatar-lg">
                      <img
                        :src="`https://claimify-api.hayokmedicare.ng/image/${auth_user.user_image}`"
                        onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'"
                        class="avatar-img rounded-circle"
                      />
                    </span>
                  </label>
                </div>
              </div>

              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <!-- <label for="inputPassword4"
                      ><strong>Select Payment Method: </strong></label -->

                    <!-- <select class="form-control" v-model="payment_type">
                      <option value="online">Pay Online</option>

                      <option value="offline">Pay Offline</option>
                    </select>  -->
                    <label for="inputPassword4"
                      ><strong>Selected Plan: </strong></label
                    >
                    <select
                      class="form-control"
                      v-model="auth_user.plan_type"
                      disabled
                    >
                      <option
                        v-for="plan in selected_plan"
                        v-bind:key="plan.id"
                        :value="plan.plan_name"
                      >
                        {{ plan.plan_name }} Plan
                      </option>
                    </select>

                    <div
                      class="col-lg-12"
                      style="margin-top: 15px; margin-bottom: 15px"
                    >
                      <div class="card m-b-30 bg-dark">
                        <div class="card-body text-white">
                          <div class="pb-2 text-center">
                            <div class="avatar avatar-lg">
                              <div
                                class="avatar-title bg-soft-primary rounded-circle"
                              >
                                <i class="fe fe-credit-card"></i>
                              </div>
                            </div>
                          </div>

                          <div class="text-center">
                            <p class="h6">
                              {{ getPlan.description }}
                            </p>
                            <p>
                              Upon payment, you will be able to access robust,
                              qualitative healthcare services as contained in
                              our benefit package. Please note that this
                              registration will be void if you do not proceed to
                              make payment. Should you have any difficulty in
                              making your payment, please call: xxxxxxx or
                              send us a mail at info@oshia.ng Thank you.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <button
                    v-if="payment_type == 'online'"
                    type="button"
                    class="btn btn-outline-dark btn-block mx-2"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                    View Payment Information
                  </button>

                  <!-- Modal -->
                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title h5" id="exampleModalLabel">
                            Payment Instruction
                          </h5>
                        </div>

                        <div class="modal-body">
                          <p class="mb-4">
                            Pay to the Account details below and upload evidence
                            of payment.
                          </p>

                          <!-- <div class="h6">
                            <p class="my-2">
                              <b>CORRESPONDENT BANK NAME: </b>
                              <span>BANK OF AMERICA</span>
                            </p>

                            

                            <p class="my-2">
                              <b>CORRESPONDENT BANK ACCOUNT NUMBER: </b>
                              <span>446053409555</span>
                            </p>

                            <p class="my-2">
                              <b>ROUTING NUMBER: </b> <span>052001633</span>
                            </p>
                          </div> -->
                          <!-- <div
                            class="fileinput fileinput-new"
                            data-provides="fileinput"
                          >
                            <span class="btn btn-file">
                              <span class="fileinput-new"
                                >Upload Payment Proof <i class="fe fe-upload"></i
                              ></span>
                              <span class="fileinput-exists">Change</span>
                              <input
                                type="file"
                                name="..."
                                multiple
                                v-on:change="attachPaymentProof"
                              />
                            </span>
                            <span class="fileinput-filename"></span>
                            <a
                              href="#"
                              class="close fileinput-exists"
                              data-dismiss="fileinput"
                              style="float: none"
                              >&times;</a
                            >
                          </div> -->
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            class="btn btn-primary"
                            data-dismiss="modal"
                            @click="addPayment"
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ENd of Payment Modal -->
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
  
  <script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
    // paystack,
  },
  data() {
    return {
      transactionID: "",
      agency_id: "",
      paymentProofFile: "",
      auth_user: "",
      amount: "",
      payment_type: "online",
      showpay: true,
      showpic: false,
      showdependent: false,
      selected_plan: [
        {
          id: 1,
          plan_name: "Individual",
          description:
            "This Plan type is a General Plan package with a 12-month duration. It only covers one person. It grants you access to affordable and qualititative healthcare coverage.",
          plan_cost: 15,
          fee: 2,
        },
        {
          id: 2,
          plan_name: "Family",
          description:
            " This Plan type is a General Plan package with a 12-month duration. It covers 6 people (One Principal and 5 Dependents). It grants you access to affordable and qualititative healthcare coverage. It allows a Maximum of 5-dependent(s).",
          plan_cost: 15,
          fee: 2,
        },
      ],
      plan_id: null,
      // paystackkey: "pk_test_551e6fe55f1f3051de41069797574751b1f65c49", //paystack public key
      paystackkey: "pk_live_1ec7b33187b214721539e421c5c89cd395502361", //paystack public key
      providers: "",
      singleplan: "",
      plans: "",
      image: "",
      imagefile: "",
      myplan: "",
      sms_message:
        "Thank you for choosing OHIS. You can come to our office to collect your ID Card in 3 weeks.",
      user: null,
      isLoading: false,
      fullPage: true,
      windowwith: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    getPlan() {
      let formatter = this.selected_plan.filter(
        (x) => x.plan_name == this.auth_user.plan_type
      );
      console.log(formatter);
      return formatter[0];
    },

    totalCost() {
      return 0;
    },

    randomTransId() {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 50; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      console.log({ result });
      return result;
    },
  },
  methods: {
    getUser() {
      this.axios
        .get(`/api/v1/user-no-auth/${this.$route.params.id}`)
        .then((response) => {
          this.auth_user = response.data.user;
          console.log(response);
          this.getShower(this.auth_user);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    addPayment() {
      if (confirm("Are you sure you want to Proceed?")) {
        // this.$router.push(`/subscribe-success/${this.$route.params.id}`);
        window.open(`/subscribe-success/${this.$route.params.id}`, "_blank");
      }
    },
  },

  created() {
    this.getUser();
  },
};
</script>
  <style scoped>
</style>
  